// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.inv_product_type_enum */
var InvProductTypeEnum;
(function (InvProductTypeEnum) {
    InvProductTypeEnum["FOOD"] = "FOOD";
    InvProductTypeEnum["CHEMICAL"] = "CHEMICAL";
    InvProductTypeEnum["CLEANING_AGENT"] = "CLEANING_AGENT";
})(InvProductTypeEnum || (InvProductTypeEnum = {}));
;
export default InvProductTypeEnum;
/** Zod schema for inv_product_type_enum */
export const invProductTypeEnum = z.nativeEnum(InvProductTypeEnum);
//# sourceMappingURL=InvProductTypeEnum.js.map